const DEFAULT_MESSAGE = "This value seems to be invalid.";

/**
 * Returns the first invalid key found in the model
 * @param  {Object} model
 * @param  {Object} validationModel
 * @return {String|null}              Name of the invalid model property
 */
export function findFirstError(model, validationModel) {
  return Object.keys(model).find((key) => key in validationModel && validationModel[key].$invalid) ?? null;
}

/**
 * Returns the error message for the first failed validator on a vuelidate
 * field model. Callers should gate on `model.$error` so this is only invoked
 * after the field is dirty (vuelidate's `$errors` array is dirty-gated).
 *
 * Resolution order, per failed validator:
 *   1. The validator's own `$message`, set via `helpers.withMessage(...)`
 *      at its definition site. Every validator the project uses ships its
 *      message this way — stock vuelidate built-ins (required, email, ...)
 *      are wrapped under `@/validators/` and project validators carry their
 *      copy inline.
 *   2. The validator's `$params.errorMessage` — the legacy convention used
 *      by the `pattern` validators in profile-form for server-supplied regex
 *      errors. New validators should prefer `helpers.withMessage` instead.
 *   3. The provided `validationMessage` arg, or DEFAULT_MESSAGE.
 */
export function getErrorMessageByValidationModel(model, validationMessage) {
  if (!model) return "";

  const first = model.$errors?.[0];
  if (!first) return "";

  if (first.$message) {
    return first.$message;
  }

  if (first.$params?.errorMessage) {
    return first.$params.errorMessage;
  }

  return validationMessage || DEFAULT_MESSAGE;
}
